<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <component v-if="layout" :is="layout"/>
    </transition>
    <b-modal v-model="showModal" ref="modal" @show="onShow" modal-class="e-modal e-first-use-modal" :hide-footer="true" :hide-header="true" centered>
      <div class="modal-content-container">
        <h3>Congratulations!</h3>        
        <div class="img-container">
          <svg height="511pt" viewBox="1 -26 511.99975 511" width="511pt" xmlns="http://www.w3.org/2000/svg">
            <g fill="#D2E3FB">
              <path d="m493.714844 97.953125c-11.792969-11.792969-27.46875-18.285156-44.148438-18.285156-16.675781 0-32.351562 6.492187-44.144531 18.285156l-211.023437 211.023437-87.851563-87.851562c-11.789063-11.789062-27.46875-18.285156-44.144531-18.285156-16.675782 0-32.351563 6.496094-44.144532 18.285156-24.34375 24.34375-24.34375 63.949219 0 88.292969l131.996094 131.996093c11.789063 11.792969 27.46875 18.285157 44.144532 18.285157 16.675781 0 32.355468-6.492188 44.144531-18.285157l255.171875-255.167968c11.789062-11.792969 18.285156-27.472656 18.285156-44.148438 0-16.675781-6.496094-32.355468-18.285156-44.144531zm0 0"/>
              <path d="m230.011719 131.226562c-12.875-4.8125-24.320313-12.175781-34.039063-21.90625-9.699218-9.691406-17.0625-21.136718-21.878906-34.027343-2.226562-5.953125-7.914062-9.902344-14.273438-9.902344-6.359374 0-12.050781 3.949219-14.277343 9.90625-4.8125 12.882813-12.175781 24.332031-21.890625 34.035156-9.707032 9.714844-21.15625 17.082031-34.035156 21.890625-5.957032 2.226563-9.910157 7.917969-9.90625 14.28125 0 6.363282 3.957031 12.054688 9.917968 14.277344 12.847656 4.785156 24.296875 12.148438 34.03125 21.878906 9.710938 9.714844 17.078125 21.164063 21.882813 34.03125 2.226562 5.957032 7.917969 9.90625 14.277343 9.90625 6.359376 0 12.046876-3.949218 14.273438-9.90625 9.671875-25.882812 30.054688-46.261718 55.914062-55.917968 5.957032-2.222657 9.90625-7.914063 9.910157-14.273438 0-6.355469-3.949219-12.046875-9.90625-14.273438zm0 0"/>
              <path d="m353.347656 52.5625c-9.703125-3.625-18.328125-9.175781-25.65625-16.511719-7.3125-7.304687-12.859375-15.933593-16.492187-25.644531-2.222657-5.957031-7.914063-9.90625-14.273438-9.90625s-12.046875 3.949219-14.273437 9.902344c-3.632813 9.714844-9.179688 18.34375-16.503906 25.660156-7.316407 7.324219-15.949219 12.875-25.652344 16.5-5.960938 2.226562-9.910156 7.917969-9.910156 14.28125.003906 6.363281 3.960937 12.054688 9.921874 14.273438 9.679688 3.605468 18.308594 9.15625 25.644532 16.492187 7.324218 7.320313 12.875 15.953125 16.5 25.652344 2.222656 5.957031 7.914062 9.902343 14.273437 9.902343s12.046875-3.945312 14.273438-9.902343c7.292969-19.511719 22.652343-34.871094 42.144531-42.148438 5.957031-2.222656 9.90625-7.914062 9.910156-14.273437 0-6.359375-3.949218-12.050782-9.90625-14.277344zm0 0"/>
            </g>
            <path d="m449.566406 79.667969c-16.675781 0-32.351562 6.492187-44.144531 18.285156l-149.4375 149.4375v176.585937l237.730469-237.734374c11.789062-11.789063 18.285156-27.46875 18.285156-44.144532 0-16.675781-6.496094-32.355468-18.285156-44.148437-11.792969-11.789063-27.46875-18.28125-44.148438-18.28125zm0 0" fill="#93BFF6"/>
            <path d="m230.011719 131.226562c-12.875-4.8125-24.320313-12.175781-34.039063-21.90625-9.699218-9.691406-17.0625-21.136718-21.878906-34.027343-2.226562-5.953125-7.914062-9.902344-14.273438-9.902344-.003906 0-.003906 0-.007812 0v160.203125h.007812c6.359376 0 12.046876-3.945312 14.273438-9.902344 9.671875-25.882812 30.054688-46.265625 55.914062-55.917968 5.957032-2.222657 9.90625-7.914063 9.910157-14.273438 0-6.355469-3.949219-12.046875-9.90625-14.273438zm0 0" fill='#93BFF6'/>
            <path d="m353.347656 52.5625c-9.703125-3.625-18.328125-9.175781-25.65625-16.511719-7.3125-7.304687-12.859375-15.933593-16.492187-25.644531-2.222657-5.957031-7.914063-9.90625-14.273438-9.90625-.003906 0-.003906 0-.003906 0v132.664062h.003906c6.359375 0 12.046875-3.945312 14.273438-9.902343 7.292969-19.511719 22.652343-34.871094 42.144531-42.148438 5.957031-2.222656 9.90625-7.914062 9.910156-14.273437 0-6.359375-3.949218-12.050782-9.90625-14.277344zm0 0" fill='#93BFF6'/>
          </svg>
        </div>
        <p>We are glad to see you on our platform. As a gift, we give you <b>10,000 EMiX</b> so that you can look at all aspects of the platform and choose a role for yourself.</p>
        <p>You want to take an introductory tour of the site?</p>
      </div>
      <div class="modal-divider"></div>
      <div class="modal-footer">
        <e-button @click="closeModal(false)" type="outlined">No</e-button>
        <e-button @click="closeModal(true)">I got it</e-button>
      </div>
    </b-modal>

    <v-tour name="firstTour" :steps="steps">
      
    </v-tour>
    <transition name="fade">
      <em-kyc/>
    </transition>

    <transition name="fade">
      <em-buy-crypto/>
    </transition>

    <transition name="fade">
      <em-forecast/>
    </transition>
  </div>
</template>

<script>
import Cookies from 'cookies-js';
import {mapActions, mapMutations, mapGetters} from 'vuex'

// Load layout components dynamically.
const requireContext = require.context('./components/layouts', false, /.*\.vue$/);

const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component.default || component;
    return components;
  }, {});

export default {
  el: '#app',

  data: () => ({
    layout: null,
    defaultLayout: 'basic',
    isTour: false,
    steps: [
      {
        target: '[data-v-step="1"]',  // We're using document.querySelector() under the hood
        content: `Your current balance is shown here.`
      },
      {
        target: '[data-v-step="2"]',
        content: '<p>All your actions on the platform will be shown here as notifications.</p><p>Looks like you already have the first alert, look it up!</p>'
      },
      {
        target: '[data-v-step="3"]',
        content: 'There will be assets you subscribed to. This is easy to do, just click on the "Subscribe" button at the top right when viewing the asset.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '[data-v-step="4"]',
        content: 'Here is a list of assets for quick access to them. On top of the tabs you can switch the type of assets.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '[data-v-step="5"]',
        content: 'In order to leave a rating, you just need to click on this button. Do this as you become familiar with the platform.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '[data-v-step="6"]',
        content: 'Or you can be a moderator. To leave the asset on any asset, click on this button.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '[data-v-step="7"]',
        content: 'Here you can quickly buy shares or tokens of any asset available on Economix',
        params: {
          placement: 'top'
        }
      },
      {
        target: '[data-v-step="8"]',
        content: 'Just do not forget that for the purchase of large amounts, you need to go through the KYC procedure. Here you can see the current status and update the information in time.',
        params: {
          placement: 'top'
        }
      }
    ]
  }),

  methods: {
    ...mapMutations('auth', ['setToken', 'setRefreshToken', 'setExpiresToken']),
    ...mapActions('auth', ['updateRefreshTimer', 'updateAuthSession', 'changeFirstUse']),
    setLayout (layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    },
    closeModal(isTour) {
      this.$refs.modal.hide();
      this.isTour = isTour;

      if(isTour) {
        this.$tours['firstTour'].start();
      }
    },
    onShow() {
      const modal = this.$refs.modal;
      const $app = this.$root.$el;
  
      $app.parentNode.appendChild(modal.$el);
    },
  },

  computed: {
    ...mapGetters('auth', {
      isFirstUse: 'isFirstUse'
    }),

    ...mapGetters('settings', {
      'isShowKyc': 'isShowKyc'
    }),

    ...mapGetters('orders', {
      'isShowBuyCrypto': 'isShowBuyCrypto'
    }),

    showModal: {
      get() {
        return this.isFirstUse
      },
      set(v) {
        this.changeFirstUse(v);
      }
    }
  },

  watch: {
    isFirstUse(v) {
      console.log(v);
    }
  },

  async beforeMount() {
    const accessToken = Cookies.get('accessToken');
    const refreshToken = Cookies.get('refreshToken');
    const expiresIn = Cookies.get('expiresToken');

    this.setToken(accessToken || null);
    this.setRefreshToken(refreshToken || null);
    this.setExpiresToken(expiresIn || null);

    // if(accessToken) {
    //   if(expiresIn * 1000 - Date.now() <= 2000) {
    //     await this.updateAuthSession();
    //   }
    //   this.updateRefreshTimer();
    // }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue